<template>
  <div>
    <div
      class="modal fade"
      id="modalConfirmarCambioPlan"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalConfirmarCambioPlanLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalConfirmarCambioPlanLabel">
              ¡Contrata con nostros!
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="container">
              <div class="row">
                <h3>Los 30 días de prueba han terminado</h3>
              </div>
              <div class="row">
                <h3>¿Quieres actualizar tu plan?</h3>
              </div>
              <div class="row">
                <h3>Estaremos escribiendote al correo</h3>
              </div>
              <div class="row">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="basic-addon1"
                      >Email</span
                    >
                  </div>
                  <input
                    type="email"
                    class="form-control"
                    v-model="correo_contacto"
                    placeholder="Correo electronico"
                    aria-label="Correo_electronico"
                    aria-describedby="basic-addon1"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="!correo_contacto.match(/\S+@\S+\.\S+/)"
              @click="enviarSolicitudContratacion"
            >
              Enviar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modalConfirmarCambioPlanINTO"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalConfirmarCambioPlanINTOLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalConfirmarCambioPlanINTOLabel">
              ¡Contrata con nostros!
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="container">
              <div class="row">
                <h3>¿Quieres actualizar tu plan?</h3>
              </div>
              <div class="row">
                <h3>Estaremos escribiendote al correo</h3>
              </div>
              <div class="row">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="basic-addon1"
                      >Email</span
                    >
                  </div>
                  <input
                    type="email"
                    class="form-control"
                    v-model="correo_contacto"
                    placeholder="Correo electronico"
                    aria-label="Correo_electronico"
                    aria-describedby="basic-addon1"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="!correo_contacto.match(/\S+@\S+\.\S+/)"
              @click="enviarSolicitudContratacion"
            >
              Enviar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      id="AlertTrial"
      v-if="$route.name != 'Login' && mostrarAlerta"
      class="alert alert-dismissible fade show"
      style="z-index: 46; margin-bottom: 0; position: sticky; top: 0"
      role="alert"
    >
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col text-center">
            Quedan <strong style="font-weight:bold;"> {{ 30 - dias_restantes_trial }} días </strong> de
            prueba, da click en el siguiente enlace para contratar uno de nuestros planes
            <a
              class="btn btn-info pt-0 pb-0"
              href="#"
              style="text-transform: none; font-weight: bold"
              @click="nuevoRequerimientoContratacion"
              >CONTRATAR UN MEJOR PLAN</a
            >
          </div>
          <div class="col-auto">
            <button
              type="button"
              id="btnCerrarAlerta"
              class="close p-0"
              data-dismiss="alert"
              aria-label="Close"
              @click="closedAlert"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <router-view />
    <div id="dfChatbot" v-if="cia.chatbot == '1'">
      <df-messenger
        df-cx="true"
        location="us-central1"
        chat-title="Asistente LMSEDK"
        agent-id="6252a600-1777-4af4-bd3f-c07f3b77259f"
        language-code="es"
        chat-icon="static/img/Robotic.png"
      ></df-messenger>
    </div>
  </div>
</template>

<script>
import VueJwtDecode from "vue-jwt-decode";
import Vue from "vue";
import { mapActions } from "vuex";
import firebase from "firebase/app";

import "firebase/messaging";
export default {
  data() {
    return {
      token: "",
      dias_restantes_trial: NaN,
      mostrarAlerta: false,
      correo_contacto: "",
    };
  },
  mounted() {
    let that = this;
    $(document).ready(() => {
      that.$http
        .get("dashboard/trial")
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          if (respuestaJson.res == "Excelente") {
            if (respuestaJson.trial) {
              this.mostrarAlerta = true;
              that.dias_restantes_trial = respuestaJson.dias;
              $(
                '#main-wrapper[data-layout="horizontal"][data-sidebar-position="fixed"] .left-sidebar'
              ).css("padding-top", "109px");
            }
          } else {
            toastr.error(
              "Error consultando la informacion del estado de la version de prueba, ponte en contacto con tu proveedor"
            );
          }
        })
        .catch((error) => {
          console.error(error);
        });
    });
    setTimeout(() => {
      $(document).ready(function () {
        const dfMessenger = document.querySelector("df-messenger");
        dfMessenger.addEventListener("df-chip-clicked", function (event) {
          if (event.detail.query == "Ver mis cursos") {
            that.$router.push({ name: "Consultar_Plan_Capacitacion" });
          }
        });
      });
    }, 1000);
  },
  created() {
    var navInfo = window.navigator.appVersion.toLowerCase();
    if (navInfo.indexOf("win") != -1) {
      this.menu.sistema_operativo = "Windows";
    } else if (navInfo.indexOf("linux") != -1) {
      this.menu.sistema_operativo = "Linux";
    } else if (navInfo.indexOf("mac") != -1) {
      this.menu.sistema_operativo = "Macintosh";
    }
    var navegador = navigator.userAgent;
    if (navegador.indexOf("Edg") > -1) {
      this.menu.navegador = "Microsoft Edge";
    } else if (navegador.indexOf("Chrome") > -1) {
      this.menu.navegador = "Google Chrome";
    } else if (navegador.indexOf("Safari") > -1) {
      this.menu.navegador = "Apple Safari";
    } else if (navegador.indexOf("Opera") > -1) {
      this.menu.navegador = "Navegador Opera";
    } else if (navegador.indexOf("Firefox") > -1) {
      this.menu.navegador = "Mozilla Firefox";
    } else if (navegador.indexOf("MSIE") > -1) {
      this.menu.navegador = "Microsoft Internet Explorer";
    }
    this.Consultar_Cia();
    this.Consultar_Token_Generico();

    $(document).ready(function () {
      // YOUR CODE (NOT RELATED TO DIALOGFLOW MESSENGER)
      window.addEventListener("dfMessengerLoaded", function (event) {
        $r1 = document.querySelector("df-messenger");
        $r2 = $r1.shadowRoot.querySelector("df-messenger-chat");
        $r3 = $r2.shadowRoot.querySelector("df-messenger-user-input"); //for other mods

        var sheet = new CSSStyleSheet();
        sheet.replaceSync(`div.chat-wrapper[opened="true"] { height: 400px }`);
        $r2.shadowRoot.adoptedStyleSheets = [sheet];
        document
          .querySelector("df-messenger")
          .shadowRoot.querySelector("df-messenger-chat")
          .shadowRoot.querySelector("df-messenger-user-input")
          .shadowRoot.querySelector(".input-box-wrapper > input").placeholder =
          "Habla con tu asistente";
        // MORE OF YOUR DIALOGFLOW MESSENGER CODE
      });
    });
  },
  methods: {
    nuevoRequerimientoContratacion() {
      $("#modalConfirmarCambioPlanINTO").modal("show");
    },
    enviarSolicitudContratacion() {
      let that = this;
      that.$http
        .post("https://www.lmsedk.com/DEMO/api/public/pub/contratarLMSEDK", {
          correo_cliente: this.correo_contacto,
        })
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          if (respuestaJson.res == "Excelente") {
            toastr.success("Solicitud enviada, pronto recibirás respuesta :)");
            this.correo_contacto = "";
            $("#modalConfirmarCambioPlan").modal("hide");
          } else {
            toastr.error(
              "Error solicitando mejora, ponte en contacto con tu proveedor"
            );
          }
        })
        .catch((error) => {
          toastr.error(
            "Error solicitando mejora, ponte en contacto con tu proveedor"
          );
        });
    },
    closedAlert() {
      $(
        '#main-wrapper[data-layout="horizontal"][data-sidebar-position="fixed"] .left-sidebar'
      ).css("padding-top", "64px");
    },
    Configurar_Notificaciones() {
      var that = this;
      if (firebase.messaging.isSupported()) {
        const messaging = firebase.messaging();
        Notification.requestPermission()
          .then(function (permission) {
            if (permission === "granted") {
              navigator.serviceWorker
                .register("./firebase-messaging-sw.js")
                .then((service) => {
                  return service;
                })
                .then((serviceJson) => {
                  messaging
                    .getToken()
                    .then((currentToken) => {
                      if (currentToken) {
                        that.Definir_TokenFCM(currentToken);
                        that.Validar_Token();
                      } else {
                        that.Validar_Token();
                      }
                    })
                    .catch((err) => {
                      that.Validar_Token();
                    });
                  messaging.onMessage((payload) => {
                    toastr.info(
                      payload.notification.title,
                      payload.notification.body
                    );
                    that.Actualizar_Notificaciones();
                  });
                })
                .catch((err) => {
                  console.log("Error al registrar el service worker", err);
                  toastr.error("Problemas para recibir notificaciones");
                  that.Validar_Token();
                });
            } else {
              toastr.error(
                "Porfavor acepta recibir notificaciones para un mejor funcionamiento"
              );
              that.Validar_Token();
            }
          })
          .catch((error) => {
            that.Validar_Token();
          });
      } else {
        that.Validar_Token();
      }
    },
    Definir_Token_Generico() {
      var that = this;
      localStorage.removeItem("apiKey_lms");
      localStorage.apiKey_lms = JSON.stringify(that.token);
      if (this.$route.name != "Descargar_ICS") {
        this.$router.push({ name: "Login" });
      } else {
        $(document).ready(function () {
          $(".preloader").hide();
        });
      }
    },
    Validar_Token() {
      var that = this;

      if (localStorage.getItem("apiKey_lms")) {
        if (JSON.parse(localStorage.apiKey_lms).length > 100) {
          var token = VueJwtDecode.decode(JSON.parse(localStorage.apiKey_lms));

          if (token.data.cve_empleado != "Generico") {
            this.$http
              .post("usuarios/login", {
                tokenfcm: that.firebase_config.tokenfcm,
              })
              .then((respuesta) => {
                return respuesta.json();
              })
              .then((respuestaJson) => {
                if (respuestaJson.length > 0) {
                  this.Actualizar_Usuario(
                    respuestaJson[0],
                    respuestaJson[0].token
                  );
                  $(document).ready(function () {
                    $(".preloader").hide();
                  });
                } else {
                  that.Definir_Token_Generico();
                }
              })
              .catch((error) => {
                that.Definir_Token_Generico();
              });
          } else {
            that.Definir_Token_Generico();
          }
        } else {
          that.Definir_Token_Generico();
        }
      } else {
        that.Definir_Token_Generico();
      }
    },
    Consultar_Token_Generico() {
      var that = this;
      this.$http
        .get("../pub/token/generico")
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          if (respuestaJson.token != undefined) {
            that.token = respuestaJson.token;
            that.Actualizar_TokenGenerico(that.token);
            that.Configurar_Notificaciones();
          } else {
            that.Definir_Token_Generico();
            swal(
              "Problemas con el servidor",
              "Favor de intentar mas tarde  (Repuesta Token Generico)",
              "error"
            );
          }
        })
        .catch((error) => {
          that.Definir_Token_Generico();
          swal(
            "Problemas para conectarse",
            "Favor de revisar su conexión a internet (Consulta Token Generico)",
            "error"
          );
        });
    },
    Actualizar_Usuario(usuario, token) {
      var that = this;
      this.$store
        .dispatch("Actualizar_Usuario", { usuario: usuario, token: token })
        .then((data) => {
          that.Actualizar_TokenFCM(that.firebase_config.tokenfcm);
          that.Validar_Permisos(token);
        });
    },
    Validar_Permisos(token) {
      var that = this;
      this.$store.dispatch("Definir_Opciones_Menu_Lateral").then((data) => {
        that.Continuar_Menu(token);
      });
    },
    Continuar_Menu(token) {
      var that = this;
      localStorage.removeItem("apiKey_lms");
      localStorage.apiKey_lms = JSON.stringify(token);
      $(document).ready(function () {
        that.Consultar_Tooltips();
        that.Escuchar_Sesion();
        that.Actualizar_Notificaciones();
        that.Actualizar_Sesiones();
      });
    },
    ...mapActions([
      "Actualizar_TokenGenerico",
      "Definir_TokenFCM",
      "Actualizar_Notificaciones",
      "Actualizar_Sesiones",
      "Escuchar_Sesion",
      "Actualizar_TokenFCM",
      "Consultar_Tooltips",
      "Consultar_Secciones",
      "Consultar_Cia",
    ]),
  },
  computed: {
    firebase_config() {
      return this.$store.getters.getFirebase_Config;
    },
    menu() {
      return this.$store.getters.getMenu;
    },
    cia() {
      return this.$store.getters.getCia;
    },
  },
};
</script>

<style>
@import url("quill/dist/quill.core.css");
@font-face {
  font-family: "Trade Gothic LT";
  src: url("/static/assetsTernium/fonts/3A0AA0_0_0.eot");
  src: url("/static/assetsTernium/fonts/3A0AA0_0_0.eot?#iefix")
      format("embedded-opentype"),
    url("/static/assetsTernium/fonts/3A0AA0_0_0.woff2") format("woff2"),
    url("/static/assetsTernium/fonts/3A0AA0_0_0.woff") format("woff"),
    url("/static/assetsTernium/fonts/3A0AA0_0_0.ttf") format("truetype");
}
@font-face {
  font-family: "Trade Gothic LT Bold Condensed";
  src: url("/static/assetsTernium/fonts/3A0AA0_2_0.eot");
  src: url("/static/assetsTernium/fonts/3A0AA0_2_0.eot?#iefix")
      format("embedded-opentype"),
    url("/static/assetsTernium/fonts/3A0AA0_2_0.woff2") format("woff2"),
    url("/static/assetsTernium/fonts/3A0AA0_2_0.woff") format("woff"),
    url("/static/assetsTernium/fonts/3A0AA0_2_0.ttf") format("truetype");
}
@font-face {
  font-family: "Trade Gothic LT Bold No. 2";
  src: url("/static/assetsTernium/fonts/3A0AA0_1_0.eot");
  src: url("/static/assetsTernium/fonts/3A0AA0_1_0.eot?#iefix")
      format("embedded-opentype"),
    url("/static/assetsTernium/fonts/3A0AA0_1_0.woff2") format("woff2"),
    url("/static/assetsTernium/fonts/3A0AA0_1_0.woff") format("woff"),
    url("/static/assetsTernium/fonts/3A0AA0_1_0.ttf") format("truetype");
}
body {
  font-family: "Arial";
  text-transform: lowercase;
}

#main-wrapper[data-layout="horizontal"][data-sidebar-position="fixed"]
  .left-sidebar {
  padding-top: 64px;
  position: fixed;
}
div::first-letter {
  text-transform: uppercase;
}
.b-form-datepicker {
  display: flex;
  padding: 0;
}

span::first-letter {
  text-transform: uppercase;
}
a::first-letter {
  text-transform: uppercase;
}
button::first-letter {
  text-transform: uppercase;
}
p::first-letter {
  text-transform: uppercase;
}
h4::first-letter {
  text-transform: uppercase;
}
h2::first-letter {
  text-transform: uppercase;
}
h3::first-letter {
  text-transform: uppercase;
}
h6::first-letter {
  text-transform: uppercase;
}
h5::first-letter {
  text-transform: uppercase;
}

th::first-letter {
  text-transform: uppercase;
}
label::first-letter {
  text-transform: uppercase;
}

.input-group-text {
  text-transform: none !important;
}

.input-group-prepend > span::first-letter {
  text-transform: uppercase !important;
}
td {
  text-transform: none;
}
.spanHeader {
  text-transform: none;
}

#textName {
  text-transform: none;
}

.buttonSection a {
  text-transform: none !important;
}
h1 {
  text-transform: none;
}
.birder-right {
  text-transform: none;
}

.skin1 {
  background: #3587d8 !important;
}
.skin2 {
  background: #d83939 !important;
}
.skin3 {
  background: #17a991 !important;
}
.skin4 {
  background: #6659f7 !important;
}
.skin5 {
  background: #333d54 !important;
}
.skin6 {
  background: #fff !important;
}
.logo_skin1 {
  background: #3587d8 !important;
}
.logo_skin2 {
  background: #d83939 !important;
}
.logo_skin3 {
  background: #17a991 !important;
}
.logo_skin4 {
  background: #6659f7 !important;
}
.logo_skin5 {
  background: #333d54 !important;
}
.logo_skin6 {
  background: #fff !important;
}
.header_skin1 {
  background: #3587d8 !important;
}
.header_skin2 {
  background: #d83939 !important;
}
.header_skin3 {
  background: #17a991 !important;
}
.header_skin4 {
  background: #6659f7 !important;
}
.header_skin5 {
  background: #333d54 !important;
}
.header_skin6 {
  background: #fff !important;
}
.menu_skin1 {
  background: #3587d8 !important;
}
.menu_skin2 {
  background: #d83939 !important;
}
.menu_skin3 {
  background: #17a991 !important;
}
.menu_skin4 {
  background: #6659f7 !important;
}
.menu_skin5 {
  background: #333d54 !important;
}
.menu_skin6 {
  background: #fff !important;
}
.bg-primary {
  background-color: #ff9900 !important;
  color: white;
}
.btn-success,
.bg-success {
  color: #fff;
  background-color: #ff9900 !important;
  border-color: #ff9900 !important;
}
.btn-warning {
  color: #fff;
  background-color: #7b7b7b !important;
  border-color: #7b7b7b !important;
}
.btn_blue {
  color: #fff;
  background-color: #007299 !important;
  border-color: #007299 !important;
}
#Nuevo_Button {
  color: #fff;
  background-color: #ff3300 !important;
  border-color: #ff3300 !important;
}

.nav-link.active {
  color: #fff !important;
  background-color: #ff3300 !important;
  border-color: #ff3300 !important;
}
.nav-link.active > span {
  color: #fff !important;
}
.page-wrapper .nav-link {
  color: #ff3300;
  background-color: #ffffff;
  border-color: #ffffff;
}
.page-wrapper .nav-link:hover {
  color: #ffffff !important;
  background-color: #ff3300;
  border-color: #ff3300;
}
.btn-primary,
.btn-outline-primary {
  color: #ffffff;
  background-color: #ff9900;
  border-color: #ff9900;
}
.btn-outline-primary:hover,
.btn-primary:hover {
  background-color: #ff990085;
  border-color: #ff990085;
  color: #ffffff;
}

.btn-primary.disabled,
.btn-primary:disabled {
  color: #fff;
  background-color: #ff9900;
  border-color: #ff9900;
}
.swal-button.swal-button--confirm {
  background-color: #7b7b7b !important;
}
#containerContentPDF {
  width: 100%;
}

.toast {
  text-transform: none !important;
}
.ql-editor,
.ql-viewer {
  text-transform: none !important;
}
.ql-viewer p,
.ql-viewer img,
.ql-viewer iframe {
  max-width: fill-available !important;
}

df-messenger {
  --df-messenger-bot-message: #7d7d7d;
  --df-messenger-button-titlebar-color: #ff3300;
  --df-messenger-chat-background-color: #fafafa;
  --df-messenger-font-color: white;
  --df-messenger-send-icon: #878fac;
  --df-messenger-user-message: #ff9900;
  text-transform: none;
}
.lert-dismissible {
  padding-right: 1rem;
}

#AlertTrial{
  background-color: #eaf6fa;
}

.btn:disabled{
  opacity: 35% !important;
}
.b-calendar-inner{
  width: 25em !important;
}
</style>




// WEBPACK FOOTER //
// src/App.vue